import { useEffect, useRef, useState } from 'react';

const services = [
  {
    icon: 'ri-heart-pulse-line',
    title: '婚外情调查',
    desc: '专业婚外情调查服务，提供确凿证据',
    items: ['行踪轨迹调查', '关系取证调查', '异常交往调查', '外遇行为取证', '婚前背景调查', '婚姻忠诚调查'],
  },
  {
    icon: 'ri-search-eye-line',
    title: '定位找人',
    desc: '找寻失踪人口、债务人、老友等各类人员',
    items: ['亲人寻找', '老友查找', '债务人查找', '失踪人口寻找', '特定人员查找', '下落不明人员查找'],
  },
  {
    icon: 'ri-briefcase-4-line',
    title: '商业调查',
    desc: '提供企业背景调查、竞争情报、商业分析等',
    items: ['企业背景调查', '商业伙伴调查', '市场竞争调查', '商业欺诈调查', '知识产权调查', '企业内部调查'],
  },
  {
    icon: 'ri-bank-card-line',
    title: '资产调查',
    desc: '调查个人或企业资产状况、债务人财产等',
    items: ['个人资产调查', '婚前财产调查', '债务人财产调查', '企业资产评估', '隐匿资产调查', '遗产继承调查'],
  },
  {
    icon: 'ri-camera-lens-line',
    title: '行为监控调查',
    desc: '对特定人员的行为进行合法监控取证',
    items: ['日常行为监控', '秘密约会取证', '可疑活动调查', '异常行为分析', '行为轨迹记录', '多媒体证据采集'],
  },
  {
    icon: 'ri-shield-check-line',
    title: '背景调查服务',
    desc: '全面了解个人或企业背景情况',
    items: ['婚恋对象背景', '求职者背景核实', '合作伙伴背景', '租户信用调查', '社会关系调查', '历史行为调查'],
  },
];

const ServiceCard = ({ s, index, visible }: { s: typeof services[0]; index: number; visible: boolean }) => (
  <div
    className="relative bg-[#162218] rounded-xl p-6 border border-[#c9a84c]/10 hover:border-[#c9a84c]/60 transition-all duration-500 group overflow-hidden w-full"
    style={{
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateY(0)' : 'translateY(30px)',
      transition: `opacity 0.6s ease ${index * 0.1}s, transform 0.6s ease ${index * 0.1}s, border-color 0.3s ease`,
    }}
  >
    {/* Shine sweep on hover */}
    <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-[#c9a84c]/8 to-transparent skew-x-12 pointer-events-none"></span>

    {/* Corner glow */}
    <span className="absolute top-0 right-0 w-20 h-20 bg-[#c9a84c]/5 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></span>

    <div className="relative z-10">
      <div className="w-12 h-12 flex items-center justify-center bg-[#c9a84c]/10 rounded-xl mb-4 group-hover:bg-[#c9a84c]/25 transition-colors duration-300">
        <i className={`${s.icon} text-2xl text-[#c9a84c]`}></i>
      </div>
      <h3 className="text-base font-bold text-white mb-1 group-hover:text-[#c9a84c] transition-colors duration-300">{s.title}</h3>
      <p className="text-xs text-white/40 mb-4">{s.desc}</p>
      <ul className="space-y-1.5">
        {s.items.map((item) => (
          <li key={item} className="flex items-center gap-2 text-xs text-white/55 group-hover:text-white/75 transition-colors duration-300">
            <i className="ri-checkbox-circle-line text-[#c9a84c] text-sm flex-shrink-0"></i>
            {item}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

const ServicesSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" className="py-20 bg-[#0f1a14] relative overflow-hidden">
      {/* Background glow blobs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#c9a84c]/3 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-[#c9a84c]/3 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-6xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-8 h-px bg-gradient-to-r from-transparent to-[#c9a84c]"></span>
            <span className="text-[#c9a84c] text-xs font-semibold tracking-widest uppercase">Our Services</span>
            <span className="w-8 h-px bg-gradient-to-l from-transparent to-[#c9a84c]"></span>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-white mb-2">专业调查服务</h2>
          <p className="text-white/35 text-sm">我们提供多种专业调查服务，满足您的不同需求</p>
        </div>

        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 justify-items-center">
          {services.map((s, i) => (
            <ServiceCard key={s.title} s={s} index={i} visible={visible} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
